import { render, staticRenderFns } from "./ApmsRegAnnualYieldForecast.vue?vue&type=template&id=065b243e&scoped=true&"
import script from "./ApmsRegAnnualYieldForecast.vue?vue&type=script&lang=js&"
export * from "./ApmsRegAnnualYieldForecast.vue?vue&type=script&lang=js&"
import style0 from "./ApmsRegAnnualYieldForecast.vue?vue&type=style&index=0&id=065b243e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065b243e",
  null
  
)

export default component.exports